import { create } from 'zustand';

const useDashboardStore = create((set, get) => ({
  // ==================== REPORT PARAMETERS ====================
  reportParameters: {},
  reportSummary: null,

  networkOptions: [],

  datasetOptions: [],
  
  timePeriodOptions: [],
  
  subnetOptions: [],

  // ==================== ACTIONS ====================
  setReportParameters: (params) => {
    set({ reportParameters: params });
    console.log('📊 Report parameters updated:', params);
  },

  clearReportParameters: () => {
    set({ reportParameters: null });
  },

  setNetworkOptions: (options) => {
    set({ networkOptions: options });
  },

  setDatasetOptions: (options) => {
    set({ datasetOptions: options });
  },
  
  setTimePeriodOptions: (options) => {
    set({ timePeriodOptions: options });
  },
  
  setSubnetOptions: (options) => {
    set({ subnetOptions: options });
  },

  setReportSummary: (summary) => {
    set({ reportSummary: summary });
  },

  // ==================== COMPUTED GETTERS ====================
  hasValidParameters: () => {
    const { reportParameters } = get();
    return (
      reportParameters &&
      reportParameters.network &&
      reportParameters.dataset &&
      reportParameters.year &&
      reportParameters.timePeriod &&
      reportParameters.subnet
    );
  },

  // ==================== CLEANUP ====================
  reset: () => {
    set({
      reportParameters: null,
    });
  },
}));

export default useDashboardStore;